import { DateInput, FormInput, DataTableEx } from '@kirz/mui-admin';
import dayjs from 'dayjs';
import React, { useContext, useMemo } from 'react';

import { Permissions } from 'constants/permissions';
import { UserContext } from 'contexts';

interface EstateActualPriceHistoryTableProps {
  estateId: number;
  onPricesChange?: (prices: { date: string; actualPrice: number }[]) => void;
}

export function EstateActualPriceHistoryTable({
  estateId,
  onPricesChange,
}: EstateActualPriceHistoryTableProps) {
  const { hasPermission } = useContext(UserContext);

  const tableSelectProps = useMemo(
    () => ({
      filter: { estateId: { _eq: estateId } },
      onFetch(items: any[]) {
        onPricesChange?.(items);
        return items;
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }),
    [estateId, onPricesChange],
  );

  return (
    <DataTableEx
      id="estate-actual-price-history"
      title="Стоимость объекта"
      source="estateActualPrice"
      columns={[
        {
          headerName: 'Дата',
          field: 'date',
          type: 'date',
          width: 100,
        },
        {
          headerName: 'Стоимость',
          field: 'actualPrice',
          flex: 1,
          type: 'number',
        },
      ]}
      sortBy={{ field: 'date', sort: 'desc' }}
      inline
      fetchAll
      {...(hasPermission(Permissions.IS_CLIENT) && {
        deletable: false,
        editable: false,
        addButton: false,
      })}
      selectProps={tableSelectProps}
      formTitle={(isNew) =>
        isNew ? 'Добавить cтоимость' : 'Редактирование cтоимости'
      }
      formDialogProps={{
        formProps: {
          defaultValues: {
            date: dayjs().format('YYYY-MM-DD'),
          },
        },
        formSubmitterProps: {
          preSubmit: (row) => ({ ...row, estateId }),
        },
      }}
    >
      <DateInput name="date" label="Дата" required />
      <FormInput name="actualPrice" label="Стоимость" type="number" required />
    </DataTableEx>
  );
}
